import { createReleaseNoteHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/ReleaseNoteHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';

export const useReleaseNotes = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['release-notes'],
    queryFn: async () => {
      if (!user?.token) throw new Error('User not authenticated');
      const tokenProvider = { getToken: async () => user.token };
      const repository = createReleaseNoteHttpRepository(tokenProvider);
      return await repository.findAll();
    },
    enabled: !!user?.token,
    staleTime: 1000 * 60 * 5,
  });
};
